import React from "react";
import {
  FaCertificate,
  FaCheckDouble,
  FaServer,
  FaExclamationTriangle,
  FaUsers,
} from "react-icons/fa";
import KpiCard from "./KpiCard";

export default function SuperadminKpiGrid({ metrics, loading }) {
  const {
    totalCertificates = 0,
    certificatesToday = 0,
    totalValidations = 0,
    validationSuccessRate = "99.4%",
    activeServicesCount = 11,
    totalServicesCount = 11,
    systemUptime = "99.9%",
    activeAlertsCount = 0,
    activeUsersCount = 0,
    totalDependenciesCount = 0,
  } = metrics || {};

  return (
    <div
      className="sad-kpi-grid"
      role="region"
      aria-label="Indicadores clave"
    >
      <KpiCard
        label="Certificados Emitidos"
        value={loading ? "..." : totalCertificates.toLocaleString()}
        icon={FaCertificate}
        iconBg="bg-[#1F2B68]"
        subtext={`${certificatesToday} emitidos hoy`}
      />

      <KpiCard
        label="Validaciones Realizadas"
        value={loading ? "..." : totalValidations.toLocaleString()}
        icon={FaCheckDouble}
        iconBg="bg-[#1B8F4D]"
        subtext={`Tasa de éxito: ${validationSuccessRate}`}
      />

      <KpiCard
        label="Microservicios Core"
        value={loading ? "..." : `${activeServicesCount}/${totalServicesCount}`}
        icon={FaServer}
        iconBg="bg-[#0284C7]"
        subtext={`Disponibilidad: ${systemUptime}`}
      />

      <KpiCard
        label="Alertas del Sistema"
        value={loading ? "..." : activeAlertsCount}
        icon={FaExclamationTriangle}
        iconBg={activeAlertsCount > 0 ? "bg-[#D97706]" : "bg-[#64748B]"}
        subtext={activeAlertsCount > 0 ? "Requieren atención" : "Sin incidentes activos"}
      />

      <KpiCard
        label="Usuarios y Dependencias"
        value={loading ? "..." : `${activeUsersCount}`}
        icon={FaUsers}
        iconBg="bg-[#7C3AED]"
        subtext={`${totalDependenciesCount} dependencias vinculadas`}
      />
    </div>
  );
}
